export const REGEX_EMAIL =
  /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
export const REGEX_PASSWORD =
  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z_@./!@#$%^*()&+-]{8,}$/;

export const REGEX_ZIP_CODE = /^\d{3}-\d{4}/;
export const REGEX_KATAKANA = /^([ァ-ン()-_/ーウォヴァィ ]|)+$/;
export const REGEX_NUMBER = /[0-9]/;
export const REGEX_ONLY_NUMBER = /^\d+$/;
export const REGEX_HTML = /<\/?[^>]+(>|$)/g;
export const KATAKANA_FULL_WIDTH = /^([ァ-ン]|ー)+$/;
